<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col>
        <Header :title="`${workplace.description}`" :subtitle="`Pracovisko ID: ${workplace.id}`" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="workplaceTasks"
          :items-per-page="15"
          class="transparent"
          :loading="loading"
        >
          <template v-slot:item.action="{ item }">
            <v-btn
              v-if="taskCommand(item) == 1"
              class="ma-1"
              color="info"
              @click="openSelectEmployee(item)"
            >POKRAČUJ</v-btn>
            <v-btn
              v-if="taskCommand(item) == 2"
              class="ma-1"
              color="primary"
              @click="openSelectEmployee(item)"
            >START</v-btn>
            <v-btn
              v-if="taskCommand(item) == 0"
              class="ma-1"
              color="warning"
              @click="stopWorkplaceTask(item)"
            >PAUZA</v-btn>
            <v-btn
              v-if="taskCommand(item) == 0"
              class="ma-1"
              color="error"
              @click="finishWorkplaceTask(item)"
            >KONIEC</v-btn>

            <!-- <v-icon>mdi-android-messages</v-icon> -->
          </template>
          <template v-slot:no-data>Žiadne položky na spracovanie</template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title primary-title>{{$t('dialogs.workplace.selectEmployeeTitle')}}</v-card-title>
        <v-card-text>
          <v-row align="center">
            <v-col cols="12">
              <v-select
                v-model="employee"
                :items="employees"
                menu-props="auto"
                label="Select"
                hide-details
                :item-text="getEmployeeName"
                :return-object="true"
                prepend-icon="mdi-account-question-outline"
                single-line
                @change="employeeChanged"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" @click="startWorkplaceTask">štart</v-btn>
          <v-btn text @click="dialog = false">zrušiť</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Header from "@/components/Header";
import _ from "lodash-es";
import { tableHeader } from "./js/workplace";

export default {
  name: "Order",
  components: { Header },
  data: () => ({
    dialog: false,
    headers: tableHeader,
    workplaces: [],
    workplaceTasks: [],
    employees: [],
    employee: {},
    startItem: {},
    loading: false,
    workplaceId: {},
    workplace: {},
    search: ""
  }),

  // computed: {
  //   formTitle() {
  //     return this.editedIndex === -1 ? "New Item" : "Edit Item";
  //   },
  //   routerValue() {
  //     console.log(this.$route.params.id);
  //     return this.$route.params.id;
  //   }
  // },

  mounted() {
    this.workplaceId = this.$route.params.id;
    this.initialize(this.workplaceId);
    this.getWorkplaceTasks(this.workplaceId);
  },

  methods: {
    initialize(workplaceId) {
      this.openGlobalLoader("Načítava sa ...");
      this.services
        .workplaceService()
        .getWorkplace(workplaceId)
        .then(response => {
          this.workplace = response.data;
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },

    getWorkplaceTasks(workplaceId) {
      //   console.log(workplace);
      this.loading = true;
      //   this.openGlobalLoader("Načítava sa ...");
      this.services
        .workplaceService()
        .getWorkplaceTasks(workplaceId)
        .then(response => {
          this.workplaceTasks = response.data;
          // this.workplace = workplace;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    openSelectEmployee(item) {
      this.startItem = item;

      this.openGlobalLoader("...");
      this.services
        .employeeService()
        .getWorkplaceEmployees()
        .then(response => {
          this.dialog = true;
          this.employees = response.data;
          this.employee = this.getDefaultEmployee(this.employees);
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },

    getDefaultEmployee(employees) {
      let employeeId = this.$cookie.get("employeeId");
      if (employeeId != null) {
        return _.find(
          employees,
          item => {
            return item.id == employeeId;
          },
          0
        );
      } else {
        let employee = employees[0];
        this.$cookie.set("employeeId", employee.id, 1);
        return employee;
      }
    },

    employeeChanged() {
      this.$cookie.set("employeeId", this.employee.id, 1);
    },

    startWorkplaceTask() {
      this.dialog = false;
      console.log(this.startItem);

      if (!confirm("Chcete začať operáciu?")) {
        return;
      }

      this.openGlobalLoader("Začínam ...");
      this.services
        .workplaceService()
        .putStartWorkplaceTask(0, this.startItem.id, this.employee.id)
        .then(response => {
          console.log(response);
          this.getWorkplaceTasks(this.workplaceId);
          this.openGlobalAlert("Operácia úšpešne začala.", "success");
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },

    stopWorkplaceTask(workplace) {
      console.log(workplace);

      if (!confirm("Chcete zastaviť operáciu?")) {
        return;
      }

      var track = workplace.manufacturingScheduleTrackers.filter(
        item => item.endTime == null
      )[0];
      console.log(track);
      this.openGlobalLoader("Načítava sa ...");
      this.services
        .workplaceService()
        .putStopWorkplaceTask(0, workplace.id, track.id)
        .then(() => {
          //this.workplaceTasks = response.data;
          this.getWorkplaceTasks(this.workplaceId);
          this.openGlobalAlert("Operácia úšpešne pozastavená.", "success");
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },

    finishWorkplaceTask(workplace) {
      console.log(workplace);

      if (!confirm("Chcete ukončiť operáciu na tomto pracovisku? Je hotová?")) {
        return;
      }

      var track = workplace.manufacturingScheduleTrackers.filter(
        item => item.endTime == null
      )[0];
      console.log(track);
      this.openGlobalLoader("Načítava sa ...");
      this.services
        .workplaceService()
        .putFinishWorkplaceTask(0, workplace.id, track.id)
        .then(() => {
          // this.workplaceTasks = response.data;
          this.getWorkplaceTasks(this.workplaceId);
          this.openGlobalAlert("Operácia úšpešne ukončená.", "success");
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },

    taskCommand(item) {
      if (
        item.manufacturingScheduleTrackers == null ||
        item.manufacturingScheduleTrackers.length == 0
      ) {
        return 2;
      }
      var track = item.manufacturingScheduleTrackers.filter(
        item => item.endTime == null
      )[0];
      if (track == null || track == undefined) {
        return 1;
      }

      return 0;
    },

    getEmployeeName(employee) {
      return `${employee.firstname} ${employee.lastname}`;
    }
  }
};
</script>
